import instance from '../utils/axios';

class ElectronicAllocationService {
    async getList(pageIndex, keyword, status) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
	      const data = {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            saleOrderId: keyword,
            sortField: 'createTime desc',
            status: status,
        }
        return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getAllocationOfCargoListForMobile', data);
    }
    async getAllocationOfCargoHost(pageIndex, orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        pageSize: 10,
        pageIndex: pageIndex,
        expressions: '[{"field": "数量", "expression": "count(1)"}]',
        sortField: 'createTime desc',
        orderId: orderId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getAllocationOfCargoHost', data);
    }
    async getHostDetailById(pageIndex, orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        pageSize: 10,
        pageIndex: pageIndex,
        expressions: '[{"field": "数量", "expression": "count(1)"}]',
        sortField: 'createTime desc',
        hostDetailId: orderId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getHostDetailById', data);
    }
    async getAllocationOfCargoMaterial(pageIndex, orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        pageSize: 10,
        pageIndex: pageIndex,
        expressions: '[{"field": "数量", "expression": "count(1)"}]',
        sortField: 'createTime desc',
        orderId: orderId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getAllocationOfCargoMaterial', data);
    }
    async getOrderInfoByOrderId(orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        orderId: orderId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getOrderInfoByOrderId', data);
    }
    async updateStatusByOrderId(orderId, status) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        status: status,
        orderId: orderId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/updateStatusByOrderId', data);
    }
    async saveDistributedQuantity(distributedQuantity, hostDetailId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        distributedQuantity: distributedQuantity,
        hostDetailId: hostDetailId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/saveDistributedQuantity', data);
    }
    async saveHostDetail(detailData, hostDetailId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        hostDetail: JSON.stringify(detailData),
        hostId: hostDetailId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/saveHostDetail', data);
    }
    async selectBarcodeAvailable(barcode) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        barcode: barcode,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/selectBarcodeAvailable', data);
    }
    async getBinInfoByBarcode(barcode) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        barcode: barcode,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getBinInfoByBarcode', data);
    }
    async getSkuIdByBarcode(barcode) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        barcode: barcode,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getSkuIdByBarcode', data);
    }
    async examineIsProduction(orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        orderId: orderId
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/examineIsProduction', data);
    }
    async getRoducableQuantity(orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        orderId: orderId
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getRoducableQuantity', data);
    }
    async createProduction(orderId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        orderId: orderId
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/createProduction', data);
    }
    async getAllocationOfCargoHostById(detailId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        detailId: detailId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getAllocationOfCargoHostById', data);
    }
    async saveMaterialDetail(skuId, skuName, materialDetail, materialId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        skuId: skuId,
        skuName: skuName,
        materialDetail:materialDetail,
        materialId: materialId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/saveMaterialDetail', data);
    }
    async saveMaterialDetailForNotCode(skuId, skuName, materialDetail, materialId) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        skuId: skuId,
        skuName: skuName,
        materialDetail:materialDetail,
        materialId: materialId,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/saveMaterialDetailForNotCode', data);
    }
    async getMaterialDetailById(skuId, materialDetail) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        skuId: skuId,
        materialDetailId:materialDetail,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getMaterialDetailById', data);
    }
    async getMaterialDetailDataById(materialDetail) {
      // eslint-disable-next-line no-mixed-spaces-and-tabs
      const data = {
        materialDetailId:materialDetail,
      }
      return await instance.post('/electronerp/elePsi/material/allocationOfCargo/getMaterialDetailDataById', data);
    }
}

export default new ElectronicAllocationService();